<p>{{getText()}}</p>
